<template>
	<div class="wrap">
		<img class="logo" src="../../assets/logo.png">
		<h3>金牌导览</h3>
		<center>探听景区精彩故事</center>
		<div class="wx-open-weapp">
			<wx-open-launch-weapp
				id="launch-btn"
				username="gh_2b15f205bba6"
				:path="path"
				@launch="handleLaunchFn"
				@error="handleErrorFn"
			>
					<div class="btn" style="width:100%;height:100%;text-align:center;line-height:15vw;color: #fff;font-weight:700;">打开小程序</div>
				<script type="text/wxtag-template">
					<style>.btn {width:100%;height:100%;text-align:center;line-height:15vw;color: #fff;font-weight:700;}</style>
					<div class="btn">打开小程序</div>
				</script>
			</wx-open-launch-weapp>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				path:""
			};
		},
		mounted() {
			this.path = localStorage.getItem('path').replace("_jid","&jid")
		},
		destroyed() {

		},
		methods: {
			handleLaunchFn (e) {
				console.log('success', e)
			},
			handleErrorFn(e){
				console.log('fail', e.detail);
			},
		},
	};
</script>

<style lang="scss" scoped>

.wx-open-weapp {
  width: 100vw;
  height: 15vw;
  margin: 15vw 0;
  #launch-btn {
    width: 100%;
    height: 100%;
    display: block;
		border: none;
		font-size: 4vw !important;
		background: #ed6c38;
		width:92vw;
		display: block;
		margin: 0 auto;
		height:15vw;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		border-radius: 4px;
	}
}
	.logo{
		display: block;
		margin: auto;
		width: 50vw;
		padding: 20vw 10vw 5vw;
	}
	h3{
		font-size: 5vw;
		text-align: center;
		margin-bottom: 3vw;
	}
	center{
		color:#666
	}
	

</style>
